import React from 'react';

export default ({ d, viewBox, title, ...props }) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox={viewBox}>
    <path d={d} fill="currentColor" />
    {title && <title id={title}>{title}</title>}
  </svg>
);
